import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as SeeIcon } from '../assets/icons/SeeIcon.svg';
import { ReactComponent as NoSeeIcon } from '../assets/icons/NoSeeIcon.svg';
import { useToast } from '../contexts/ToastContext';

const BACKEND_URL = 'https://backend-288175208699.europe-west1.run.app';

const SuccessModal = ({ isOpen, onClose, unido }) => {
    if (!isOpen) return null;
    return (
        <div className="modal-backdrop">
            <div className="modal-content">
                <div className="modal-close" onClick={onClose}>&times;</div>
                <h1>REGISTRO COMPLETADO CON ÉXITO</h1>
                {unido ? (
                    <>
                        <p>Hemos creado su cuenta y lo hemos sumado a nuestra lista de espera exclusiva.</p>
                        <p>Nos comunicaremos con usted en cuanto un cupo de asignación esté disponible. A partir de ahora, recibirá también nuestras comunicaciones con acceso prioritario a eventos y degustaciones.</p>
                    </>
                ) : (
                    <>
                        <p>Hemos creado su cuenta correctamente. Ya puede iniciar sesión con su email y contraseña.</p>
                        <p>Cuando quiera, desde su perfil va a poder sumarse a la lista de espera para acceder a un cupo de compra.</p>
                    </>
                )}
                <button className="modal-button" onClick={onClose}>Ingresar</button>
            </div>
        </div>
    );
};

const MensajeError = ({ mensaje }) => (
    <span className="mensaje-obligatorio">{mensaje}</span>
);

const isAdult = (dateOfBirth) => {
    if (!dateOfBirth) return true;
    const parts = dateOfBirth.split('/');
    if (parts.length !== 3) return false;
    const formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
    const today = new Date();
    const birthDate = new Date(formattedDate);
    if (isNaN(birthDate)) return false;
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age >= 18;
};

const formatDateInput = (value) => {
    let digits = value.replace(/\D/g, '');
    let formatted = '';
    if (digits.length > 0) {
        formatted += digits.substring(0, 2);
    }
    if (digits.length >= 3) {
        formatted += '/' + digits.substring(2, 4);
    }
    if (digits.length >= 5) {
        formatted += '/' + digits.substring(4, 8);
    }
    return formatted;
};

const formatDateForSubmission = (dateString) => {
    if (!dateString) return '';
    const parts = dateString.split('/');
    if (parts.length === 3) {
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    return dateString;
};

function Registrarse() {
    const navigate = useNavigate();
    const { showToast } = useToast();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [errors, setErrors] = useState({});
    const initialFormData = {
        nombre: '', apellido: '', contrasena: '', repetirContrasena: '',
        email: '', repetirEmail: '', telefono: '',
        calle: '', altura: '', ciudad: '', codigoPostal: '', pais: '',
        titulo: '', empresa: '', fechaDeNacimiento: '', unirseListaEspera: false
    };
    const [formData, setFormData] = useState(initialFormData);
    const [seUnioALista, setSeUnioALista] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showRepeatPassword, setShowRepeatPassword] = useState(false);

    const togglePasswordVisibility = (field) => {
        if (field === 'contrasena') {
            setShowPassword(prev => !prev);
        } else if (field === 'repetirContrasena') {
            setShowRepeatPassword(prev => !prev);
        }
    };

    const checkMatchError = (name, value, newErrors) => {
        if (name === 'contrasena' || name === 'repetirContrasena') {
            const currentContrasena = name === 'contrasena' ? value : formData.contrasena;
            const currentRepetirContrasena = name === 'repetirContrasena' ? value : formData.repetirContrasena;
            if (currentContrasena === currentRepetirContrasena && currentContrasena !== '') {
                delete newErrors.contrasena;
                delete newErrors.repetirContrasena;
            } else if (currentContrasena !== currentRepetirContrasena && currentRepetirContrasena !== '') {
                newErrors.repetirContrasena = 'Las contraseñas no coinciden';
            }
        }
        if (name === 'email' || name === 'repetirEmail') {
            const currentEmail = name === 'email' ? value : formData.email;
            const currentRepetirEmail = name === 'repetirEmail' ? value : formData.repetirEmail;
            if (currentEmail === currentRepetirEmail && currentEmail !== '') {
                delete newErrors.email;
                delete newErrors.repetirEmail;
            } else if (currentEmail !== currentRepetirEmail && currentRepetirEmail !== '') {
                newErrors.repetirEmail = 'Los emails no coinciden';
            }
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (name === 'fechaDeNacimiento') return;
        const nuevoValor = type === 'checkbox' ? checked : value;
        setFormData(prevData => ({
            ...prevData,
            [name]: nuevoValor
        }));
        if (type === 'checkbox') return;
        const newErrors = { ...errors };
        if (value.trim() !== '') {
            delete newErrors[name];
        } else {
            const requiredFields = [
                'nombre', 'apellido', 'fechaDeNacimiento', 'contrasena', 'repetirContrasena',
                'email', 'repetirEmail', 'telefono', 'calle', 'altura', 'ciudad',
                'codigoPostal', 'pais'
            ];
            if (requiredFields.includes(name)) {
                newErrors[name] = 'Este campo es obligatorio';
            }
        }
        checkMatchError(name, value, newErrors);
        setErrors(newErrors);
    };

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        const formattedValue = formatDateInput(value);
        setFormData(prevData => ({
            ...prevData,
            [name]: formattedValue
        }));
        const newErrors = { ...errors };
        if (formattedValue.trim() === '') {
            newErrors[name] = 'Este campo es obligatorio';
        } else if (formattedValue.length === 10) {
            if (!isAdult(formattedValue)) {
                newErrors.fechaDeNacimiento = 'Debes ser mayor de edad (18 años) para inscribirte';
            } else {
                delete newErrors.fechaDeNacimiento;
            }
        } else {
            delete newErrors.fechaDeNacimiento;
        }
        setErrors(newErrors);
    };

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            'nombre', 'apellido', 'fechaDeNacimiento',
            'contrasena', 'repetirContrasena',
            'email', 'repetirEmail', 'telefono',
            'calle', 'altura', 'ciudad',
            'codigoPostal', 'pais'
        ];
        requiredFields.forEach(fieldId => {
            if (!formData[fieldId] || formData[fieldId].trim() === '') {
                newErrors[fieldId] = 'Este campo es obligatorio';
            }
        });
        if (formData.fechaDeNacimiento && !newErrors.fechaDeNacimiento && !isAdult(formData.fechaDeNacimiento)) {
            newErrors.fechaDeNacimiento = 'Debes ser mayor de edad (18 años) para inscribirte';
        }
        if (formData.contrasena !== formData.repetirContrasena) {
            newErrors.repetirContrasena = 'Las contraseñas no coinciden';
        }
        if (formData.email !== formData.repetirEmail) {
            newErrors.repetirEmail = 'Los emails no coinciden';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        const dataForSubmission = { ...formData };
        dataForSubmission.fechaDeNacimiento = formatDateForSubmission(formData.fechaDeNacimiento);
        try {
            const response = await fetch(`${BACKEND_URL}/registrar-cuenta`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(dataForSubmission),
            });
            const result = await response.json();
            if (response.ok) {
                setSeUnioALista(formData.unirseListaEspera);
                setIsModalOpen(true);
                setFormData(initialFormData);
                setErrors({});
            } else {
                showToast(`Error: ${result.error}`, 'error');
                console.error("Error del servidor:", result.error);
            }
        } catch (error) {
            showToast("Error de conexión con el servidor.", 'error');
            console.error("Error de red o fetch:", error);
        }
    };

    const getInputClassName = (fieldId) => {
        return errors[fieldId] ? 'input-error-borde' : '';
    };

    return (
        <div className="historia-container" style={{ alignItems: 'stretch' }}>
            <SuccessModal
                isOpen={isModalOpen}
                onClose={() => { setIsModalOpen(false); navigate('/acceso-miembros'); }}
                unido={seUnioALista}
            />
            <div className="contenido-scrollable">
                <div className="titulo-principal">
                    <hr className="linea-horizontal" />
                    <h1>ALTA DE MEMBRESÍA</h1>
                    <hr className="linea-horizontal" />
                </div>
                <p className="contenido-centrado" style={{ paddingBottom: '15px' }}>
                    Para registrarse, por favor complete el siguiente formulario:
                </p>
                <p className="contenido-centrado" style={{ paddingBottom: '15px', color: '#8f1941' }}>
                    (*) Campos obligatorios
                </p>
                <form className="formulario-lista" onSubmit={handleSubmit} noValidate>
                    <h2>información de contacto</h2>
                    <div className="form-group-grid">
                        <div className="form-group">
                            <label htmlFor="nombre"><p className='asterisco'>*</p>Nombre</label>
                            <div className="input-con-error">
                                <input type="text" id="nombre" name="nombre" value={formData.nombre} onChange={handleChange} className={getInputClassName('nombre')} />
                                {errors.nombre && <MensajeError mensaje={errors.nombre} />}
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="apellido"><p className='asterisco'>*</p>Apellido</label>
                            <div className="input-con-error">
                                <input type="text" id="apellido" name="apellido" value={formData.apellido} onChange={handleChange} className={getInputClassName('apellido')} />
                                {errors.apellido && <MensajeError mensaje={errors.apellido} />}
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="fechaDeNacimiento"><p className='asterisco'>*</p>Fecha de Nacimiento</label>
                            <div className="input-con-error">
                                <input
                                    type="text"
                                    maxLength="10"
                                    id="fechaDeNacimiento"
                                    name="fechaDeNacimiento"
                                    value={formData.fechaDeNacimiento}
                                    onChange={handleDateChange}
                                    className={getInputClassName('fechaDeNacimiento')}
                                    placeholder="DD/MM/YYYY"
                                    style={{ textAlign: 'center' }}
                                />
                                {errors.fechaDeNacimiento && <MensajeError mensaje={errors.fechaDeNacimiento} />}
                            </div>
                        </div>
                    </div>
                    <h2>creación de usuario</h2>
                    <div className="form-group-grid">
                        <div className="form-group">
                            <label htmlFor="contrasena"><p className='asterisco'>*</p>Contraseña</label>
                            <div className="input-con-error">
                                <div className="input-password-wrapper">
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        id="contrasena"
                                        name="contrasena"
                                        value={formData.contrasena}
                                        onChange={handleChange}
                                        className={getInputClassName('contrasena')}
                                    />
                                    <button
                                        type="button"
                                        className="password-toggle-button"
                                        onClick={() => togglePasswordVisibility('contrasena')}
                                    >
                                        {showPassword ? <NoSeeIcon style={{ height: '15px', overflow: 'visible', width: 'auto', margin: 'auto 0' }} /> : <SeeIcon style={{ height: '15px', overflow: 'visible', width: 'auto', margin: 'auto 0' }} />}
                                    </button>
                                </div>
                                {errors.contrasena && <MensajeError mensaje={errors.contrasena} />}
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="repetirContrasena"><p className='asterisco'>*</p>Repetir Contraseña</label>
                            <div className="input-con-error">
                                <div className="input-password-wrapper">
                                    <input
                                        type={showRepeatPassword ? 'text' : 'password'}
                                        id="repetirContrasena"
                                        name="repetirContrasena"
                                        value={formData.repetirContrasena}
                                        onChange={handleChange}
                                        className={getInputClassName('repetirContrasena')}
                                    />
                                    <button
                                        type="button"
                                        className="password-toggle-button"
                                        onClick={() => togglePasswordVisibility('repetirContrasena')}
                                    >
                                        {showRepeatPassword ? <NoSeeIcon style={{ height: '15px', overflow: 'visible', width: 'auto', margin: 'auto 0' }} /> : <SeeIcon style={{ height: '15px', overflow: 'visible', width: 'auto', margin: 'auto 0' }} />}
                                    </button>
                                </div>
                                {errors.repetirContrasena && <MensajeError mensaje={errors.repetirContrasena} />}
                            </div>
                        </div>
                    </div>
                    <div className="form-group-grid">
                        <div className="form-group">
                            <label htmlFor="titulo">Título</label>
                            <input type="text" id="titulo" name="titulo" value={formData.titulo} onChange={handleChange} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="empresa">Empresa</label>
                            <input type="text" id="empresa" name="empresa" value={formData.empresa} onChange={handleChange} />
                        </div>
                    </div>
                    <div className="form-group-grid direccion-grid">
                        <div className="form-group">
                            <label htmlFor="calle"><p className='asterisco'>*</p>Calle</label>
                            <div className="input-con-error">
                                <input
                                    type="text"
                                    id="calle"
                                    name="calle"
                                    value={formData.calle}
                                    onChange={handleChange}
                                    className={getInputClassName('calle')}
                                />
                                {errors.calle && <MensajeError mensaje={errors.calle} />}
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="altura"><p className='asterisco'>*</p>Altura</label>
                            <div className="input-con-error">
                                <input
                                    type="text"
                                    id="altura"
                                    name="altura"
                                    value={formData.altura}
                                    onChange={handleChange}
                                    className={getInputClassName('altura')}
                                />
                                {errors.altura && <MensajeError mensaje={errors.altura} />}
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="ciudad"><p className='asterisco'>*</p>Ciudad/ Localidad/ Provincia</label>
                            <div className="input-con-error">
                                <input
                                    type="text"
                                    id="ciudad"
                                    name="ciudad"
                                    value={formData.ciudad}
                                    onChange={handleChange}
                                    className={getInputClassName('ciudad')}
                                />
                                {errors.ciudad && <MensajeError mensaje={errors.ciudad} />}
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="codigoPostal"><p className='asterisco'>*</p>Código Postal</label>
                            <div className="input-con-error">
                                <input type="text" id="codigoPostal" name="codigoPostal" value={formData.codigoPostal} onChange={handleChange} className={getInputClassName('codigoPostal')} />
                                {errors.codigoPostal && <MensajeError mensaje={errors.codigoPostal} />}
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="pais"><p className='asterisco'>*</p>País</label>
                            <div className="input-con-error">
                                <input type="text" id="pais" name="pais" value={formData.pais} onChange={handleChange} className={getInputClassName('pais')} />
                                {errors.pais && <MensajeError mensaje={errors.pais} />}
                            </div>
                        </div>
                    </div>
                    <div className="form-group-grid">
                        <div className="form-group">
                            <label htmlFor="email"><p className='asterisco'>*</p>Email</label>
                            <div className="input-con-error">
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    className={getInputClassName('email')}
                                />
                                {errors.email && <MensajeError mensaje={errors.email} />}
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="repetirEmail"><p className='asterisco'>*</p>Repetir Email</label>
                            <div className="input-con-error">
                                <input
                                    type="email"
                                    id="repetirEmail"
                                    name="repetirEmail"
                                    value={formData.repetirEmail}
                                    onChange={handleChange}
                                    className={getInputClassName('repetirEmail')}
                                />
                                {errors.repetirEmail && <MensajeError mensaje={errors.repetirEmail} />}
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="telefono"><p className='asterisco'>*</p>Teléfono</label>
                            <div className="input-con-error">
                                <input type="tel" id="telefono" name="telefono" value={formData.telefono} onChange={handleChange} className={getInputClassName('telefono')} />
                                {errors.telefono && <MensajeError mensaje={errors.telefono} />}
                            </div>
                        </div>
                    </div>
                    <label className="checkbox-container" style={{ marginTop: '20px' }}>
                        <input
                            type="checkbox"
                            name="unirseListaEspera"
                            checked={formData.unirseListaEspera}
                            onChange={handleChange}
                        />
                        <span className="checkbox-checkmark"></span>
                        <span className="checkbox-label-text">
                            Quiero ser miembro de la Lista de Espera del proyecto «P195»
                        </span>
                    </label>
                    <hr className="linea-horizontal" style={{ margin: '30px 0 15px', padding: '0' }} />
                    <button type="submit" className="boton-inscribirse">
                        Suscribirse
                    </button>
                </form>
            </div>
        </div>
    );
}

export default Registrarse;
